import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _IpFilter;
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import partial from 'lodash/partial';
import debounce from 'lodash/debounce';
import { List } from 'immutable';
import ipaddr from 'ipaddr.js';
import { Button } from '@instructure/ui-buttons';
import { IconTrashLine } from '@instructure/ui-icons';
import { Link } from '@instructure/ui-link';
import { PresentationContent, ScreenReaderContent } from '@instructure/ui-a11y-content';
import { jsx } from '@instructure/emotion';
import t from '@instructure/quiz-i18n/es/format-message';
import Setting from '../Setting';
import { FilterAsyncSearch } from '../FilterAsyncSearch';
import generateComponentTheme from './theme';
import generateStyle from './styles';
import { withStyleOverrides, TextInput, FormFieldGroup } from '@instructure/quiz-common';
var START_RANGE_INPUT_INDEX = 0;
var END_RANGE_INPUT_INDEX = 1;
var DELETE_FILTER_INDEX = 2;
export var IpFilter = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_IpFilter = /*#__PURE__*/function (_Component) {
  function IpFilter() {
    var _this;
    _classCallCheck(this, IpFilter);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, IpFilter, [].concat(args));
    _defineProperty(_this, "state", {
      errors: List()
    });
    _defineProperty(_this, "filterRefs", List());
    _defineProperty(_this, "setIpFilters", function (ips) {
      _this.props.setIpFiltersUi(_this.props.activeQuizId, ips, _this.namedIpFilters);
      _this.updateIpFiltersApi();
    });
    _defineProperty(_this, "focusOnFilter", function () {
      var setFocusOnColumnIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var setFocusOnRowIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      setTimeout(function () {
        var rowFocusIndex = setFocusOnRowIndex;
        if (rowFocusIndex === null) {
          rowFocusIndex = _this.ipFilters.size - 1;
        }
        var filter = _this.filterRefs.getIn([rowFocusIndex, setFocusOnColumnIndex]);
        filter && filter.focus();
      });
    });
    _defineProperty(_this, "updateIpFiltersApi", debounce(function () {
      // Individual inputs will always be valid in the store,
      // but we still need to filter out those that are an invalid range as a pair.
      var validFilters = _this.ipFilters.filter(function (filterValues) {
        return !_this.getRangeErrors(filterValues);
      });
      if (validFilters.isEmpty()) {
        validFilters = List([List(['', ''])]);
      }
      _this.props.setIpFiltersApi(_this.props.activeQuizId, validFilters, _this.namedIpFilters, _this.changeCompleteCb);
    }));
    _defineProperty(_this, "setFilterRef", function (index, rangePart, ref) {
      if (!_this.filterRefs.has(index)) {
        _this.filterRefs = _this.filterRefs.set(index, List());
      }
      _this.filterRefs = _this.filterRefs.setIn([index, rangePart], ref);
    });
    _defineProperty(_this, "setAddFilterRef", function (node) {
      _this.addFilterRef = node;
    });
    _defineProperty(_this, "getFilterValues", function (filters, index) {
      if (_this.state.errors.get(index) && _this.filterRefs.get(index)) {
        return _this.filterRefs.get(index).map(function (ref) {
          return ref ? ref.value : '';
        });
      }
      return filters;
    });
    _defineProperty(_this, "toggleFilterIpAddress", function (event, changeCompleteCb) {
      var value = event.target.checked;
      if (!value) {
        _this.setState({
          errors: List()
        });
      }
      _this.props.setFilterIpAddress(_this.props.activeQuizId, value, changeCompleteCb);
    });
    _defineProperty(_this, "handleFilterAdd", function (event) {
      _this.setIpFilters(_this.ipFilters.push(List(['', ''])));
      _this.focusOnFilter();
      _this.props.screenreaderNotification(t('Ip Filter Range Input Fields added.'));
    });
    _defineProperty(_this, "handleFilterRemove", function (index) {
      // Remove saved node refs and errors too
      _this.filterRefs = _this.filterRefs.remove(index);
      _this.setState({
        errors: _this.state.errors.remove(index)
      });
      var columnFocusIndex = _this.ipFilters.size > 2 ? DELETE_FILTER_INDEX : START_RANGE_INPUT_INDEX;
      var rowFocusIndex = _this.ipFilters.size - 1 === index ? index - 1 : index;
      _this.setIpFilters(_this.ipFilters.remove(index));
      _this.focusOnFilter(columnFocusIndex, rowFocusIndex);
      _this.props.screenreaderNotification(t('Ip Filter Range Input Field removed.'));
    });
    _defineProperty(_this, "handleFilterChange", function (index, rangePart, event) {
      var ipval = event.target.value.trim();
      var filterErrs = _this.state.errors.get(index) || List();
      if (!_this.hasNoLeadingZeroes(ipval)) {
        // has leading zeroes
        filterErrs = filterErrs.set(rangePart, t('IP Address cannot contain leading zeroes.'));
      } else if (ipval !== '' && !(ipaddr.IPv4.isValid(ipval) && /\./.test(ipval))) {
        // invalid for other reason
        // { ip: event.target.value } is used (instead of { ip: ipval })
        // because ipval is a trimmed string. With ipval, inputting an invalid string
        // with trailing space won't trigger a component rendering, which may cause
        // un-removable trailing spaces.
        filterErrs = filterErrs.set(rangePart, t('IP address {ip} is invalid, correct format: 000.000.000.000', {
          ip: event.target.value
        }));
      } else {
        // valid IP address
        filterErrs = filterErrs.set(rangePart, null);
        _this.setIpFilters(_this.ipFilters.setIn([index, rangePart], ipval));
      }

      // See if we can clear out the errors for this while thing
      if (filterErrs.filter(function (x) {
        return !!x;
      }).size === 0) {
        _this.setState({
          errors: _this.state.errors.remove(index)
        });
      } else {
        _this.setState({
          errors: _this.state.errors.set(index, filterErrs)
        });
      }
    });
    _defineProperty(_this, "handleSearchSelectionChange", function (selectedFilters) {
      _this.props.setIpFiltersUi(_this.props.activeQuizId, _this.ipFilters, selectedFilters);
      _this.updateIpFiltersApi();
    });
    // =================
    //   ERROR HELPERS
    // =================
    _defineProperty(_this, "hasNoLeadingZeroes", function (ipval) {
      var _iterator = _createForOfIteratorHelper(ipval.split('.')),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var val = _step.value;
          if (val != '0' && val[0] === '0') {
            return false; // contains at least one leading zero
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return true; // contains no leading zeroes
    });
    _defineProperty(_this, "rangeIsValid", function (lhs, rhs) {
      for (var i = 0; i < 4; i++) {
        if (lhs[i] > rhs[i]) {
          return false;
        } else if (lhs[i] < rhs[i]) {
          return true;
        }
      }
      return true;
    });
    _defineProperty(_this, "getRangeErrors", function (values) {
      var startval = values.get(START_RANGE_INPUT_INDEX);
      var endval = values.get(END_RANGE_INPUT_INDEX);
      if (!startval && !endval) {
        return null; // ignore fully empty ranges
      } else if (!startval || !endval) {
        return List([t('Incomplete IP range')]);
      } else if (ipaddr.IPv4.isValid(startval) && ipaddr.IPv4.isValid(endval)) {
        try {
          var rangeStart = ipaddr.parse(startval);
          var rangeEnd = ipaddr.parse(endval);
          if (!_this.rangeIsValid(rangeStart.octets, rangeEnd.octets)) {
            // compare  IPs in the same family using the first > or < byte
            return List([t('Invalid IP range: {rangeStart} is greater than {rangeEnd}', {
              rangeStart: startval,
              rangeEnd: endval
            })]);
          }
        } catch (_unused) {
          // This is already taken care of by the first portion of the validation
        }
      }
    });
    _defineProperty(_this, "getInputRangeErrors", function (index, subindex, values, transformToErrorObjects) {
      var errorsAtIndex = (_this.state.errors.get(index) || List()).get(subindex);
      var rangeInputError = errorsAtIndex ? [errorsAtIndex] : [];
      var rangeErrors = subindex == 0 ? _this.getRangeErrors(values) || [] : [];
      var rangeInputErrors = [].concat(rangeInputError, _toConsumableArray(rangeErrors));
      var mapped = rangeInputErrors.map(function (error) {
        return {
          type: error ? 'error' : null,
          text: error
        };
      });
      return transformToErrorObjects ? _toConsumableArray(mapped) : List(_toConsumableArray(rangeInputErrors));
    });
    _defineProperty(_this, "renderIpFilter", function (filter, index) {
      var values = _this.getFilterValues(filter, index);
      var rangeStartMessage = index == 0 ? [{
        text: t('ex: 000.000.000.000'),
        type: 'hint'
      }] : [];
      var rangeEndMessage = index == 0 ? [{
        text: t('ex: 255.255.255.255'),
        type: 'hint'
      }] : [];
      var rangeStartErrors = _this.getInputRangeErrors(index, 0, values, true);
      var rangeEndErrors = _this.getInputRangeErrors(index, 1, values, true);
      return jsx("div", {
        key: index,
        css: _this.props.styles.filterItem
      }, jsx(TextInput, {
        renderLabel: jsx(ScreenReaderContent, null, t('Range Start')),
        display: "inline-block",
        type: "text",
        width: "13.5rem",
        defaultValue: values.get(START_RANGE_INPUT_INDEX),
        ref: partial(_this.setFilterRef, index, START_RANGE_INPUT_INDEX),
        onChange: partial(_this.handleFilterChange, index, START_RANGE_INPUT_INDEX),
        "data-automation": "sdk-ipFiltering-start",
        messages: rangeStartErrors.length > 0 ? rangeStartErrors : rangeStartMessage
      }), jsx("span", {
        css: _this.props.styles.rangeSeparator
      }, t({
        id: 'ip_range_separator',
        "default": 'to',
        description: 'word to separate an ip address range'
      })), jsx(TextInput, {
        renderLabel: jsx(ScreenReaderContent, null, t('Range End')),
        display: "inline-block",
        type: "text",
        width: "13.5rem",
        defaultValue: values.get(END_RANGE_INPUT_INDEX),
        ref: partial(_this.setFilterRef, index, END_RANGE_INPUT_INDEX),
        onChange: partial(_this.handleFilterChange, index, END_RANGE_INPUT_INDEX),
        "data-automation": "sdk-ipFiltering-end",
        messages: rangeEndErrors.length > 0 ? rangeEndErrors : rangeEndMessage
      }), _this.renderTrashButton(index));
    });
    return _this;
  }
  _inherits(IpFilter, _Component);
  return _createClass(IpFilter, [{
    key: "changeCompleteCb",
    value: function changeCompleteCb() {}
  }, {
    key: "ipFilters",
    get: function get() {
      return this.props.filters.get('ips', List([List(['', ''])]));
    }
  }, {
    key: "namedIpFilters",
    get: function get() {
      return this.props.filters.get('namedIps', List());
    }
  }, {
    key: "renderTrashButton",
    value:
    // =============
    //   RENDERING
    // =============

    function renderTrashButton(index) {
      // Cannot delete the final item
      if (index === 0 && this.ipFilters.size === 1) {
        return null;
      }
      var iconText = t('Delete empty IP filter');
      var _this$getFilterValues = this.getFilterValues(this.ipFilters.get(index), index),
        _this$getFilterValues2 = _slicedToArray(_this$getFilterValues, 2),
        rangeStart = _this$getFilterValues2[0],
        rangeEnd = _this$getFilterValues2[1];
      if (rangeStart && rangeEnd) {
        iconText = t('Delete IP filter spanning {rangeStart} to {rangeEnd}', {
          rangeStart: rangeStart,
          rangeEnd: rangeEnd
        });
      } else if (rangeStart) {
        iconText = t('Delete incomplete IP filter starting with {rangeStart}', {
          rangeStart: rangeStart
        });
      } else if (rangeEnd) {
        iconText = t('Delete incomplete IP filter ending with {rangeEnd}', {
          rangeEnd: rangeEnd
        });
      }
      return jsx(Button, {
        size: "medium",
        margin: "0 0 0 small",
        onClick: partial(this.handleFilterRemove, index),
        ref: partial(this.setFilterRef, index, DELETE_FILTER_INDEX),
        renderIcon: IconTrashLine
      }, jsx(ScreenReaderContent, null, iconText));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      if (this.props.namedFiltersOn) {
        return jsx(Setting, {
          automationData: "sdk-ipFiltering-toggle",
          label: t('Filter IP addresses'),
          isChecked: this.props.filterIpAddress,
          showMore: this.props.filterIpAddress,
          onChange: this.toggleFilterIpAddress
        }, function (changeCompleteCb) {
          _this2.changeCompleteCb = changeCompleteCb;
          return jsx("div", {
            css: _this2.props.styles.container
          }, jsx("div", {
            css: _this2.props.styles.sectionWrapper
          }, jsx(FormFieldGroup, {
            as: "div",
            vAlign: "top",
            rowSpacing: "small",
            description: t('Input custom group range')
          }, _this2.ipFilters.toArray().map(_this2.renderIpFilter), jsx(Link, {
            elementRef: _this2.setAddFilterRef,
            onClick: _this2.handleFilterAdd,
            isWithinText: false
          }, jsx(PresentationContent, null, t('+ Allowed range')), jsx(ScreenReaderContent, null, t('add allowed range'))))), jsx("div", {
            css: _this2.props.styles.sectionWrapper
          }, jsx(FilterAsyncSearch, {
            getNamedIpFilters: _this2.props.getNamedIpFilters,
            onSelectionChange: _this2.handleSearchSelectionChange,
            selectedFilters: _this2.namedIpFilters,
            searchLabel: t('Select from existing group ranges')
          })));
        });
      } else {
        return jsx(Setting, {
          automationData: "sdk-ipFiltering-toggle",
          label: t('Filter IP addresses'),
          isChecked: this.props.filterIpAddress,
          showMore: this.props.filterIpAddress,
          onChange: this.toggleFilterIpAddress
        }, function (changeCompleteCb) {
          _this2.changeCompleteCb = changeCompleteCb;
          return jsx("div", {
            css: _this2.props.styles.sectionWrapper
          }, t('Allowed IP range'), _this2.ipFilters.toArray().map(_this2.renderIpFilter), jsx(Link, {
            elementRef: _this2.setAddFilterRef,
            onClick: _this2.handleFilterAdd
          }, jsx(PresentationContent, null, t('+ Allowed range')), jsx(ScreenReaderContent, null, t('add allowed range'))));
        });
      }
    }
  }]);
}(Component), _defineProperty(_IpFilter, "displayName", 'IpFilter'), _defineProperty(_IpFilter, "componentId", "Quizzes".concat(_IpFilter.displayName)), _defineProperty(_IpFilter, "propTypes", {
  activeQuizId: PropTypes.string.isRequired,
  filterIpAddress: PropTypes.bool.isRequired,
  filters: ImmutablePropTypes.map.isRequired,
  getNamedIpFilters: PropTypes.func,
  namedFiltersOn: PropTypes.bool,
  screenreaderNotification: PropTypes.func.isRequired,
  setFilterIpAddress: PropTypes.func.isRequired,
  setIpFiltersApi: PropTypes.func.isRequired,
  setIpFiltersUi: PropTypes.func.isRequired,
  styles: PropTypes.object
}), _defineProperty(_IpFilter, "defaultProps", {
  getNamedIpFilters: function getNamedIpFilters() {},
  namedFiltersOn: false
}), _IpFilter)) || _class);
export default IpFilter;